export const theme = {
    fontSizes: [
        '0.625rem', // 0 - 10px - <p> XS
        '0.6875rem', // 1 - 11px - <p> S
        '0.75rem', // 2 - 12px - <p> M
        '0.8125rem', // 3 - 13px - <p> L
        '0.875rem', // 4 - 14px - <p> XL
        '1rem', // 5 - 16px - H3
        '1.125rem', // 6 - 18px - H2
        '1.3125rem', // 7 - 21px -H1
        '2.25rem', // 8 - 36px
        '3.75rem', // 9 - 60px
        '8.75rem', // 10 - 140px
    ],
    breakPoints: [
        '30rem', // 0 - 480px
        '48rem', // 1 - 768px
        '64rem', // 2 - 1024px
        '90rem', // 3 - 1440px
        '120rem', // 4 - 1920px
    ],
    colors: {
        bgPrimary: '#F1F6F8',
        bgSecondary: '#223751',
        bgTernary: '#F4F6F7',
        logoPrimary: '#49B187',
        fontPrimary: '#292929',
        fontPrimaryDisabled: '#7C8B9F',
        fontSecondary: '#223751',
        fontTertiary: '#7A7A7A',
        fontSearch: '#8C8C8C',
        fontTableHead: '#636363',
        optionBg: 'rgba(0, 0, 0, 0.042)',
        checkbox: '#223751',
        checkboxBorder: '#359F84',
        recommended: '#4FAEBC',
        badge: '#E9F7F9',
        badgeFont: '#3E8E9A',
        contacted: '#D97712',
        responded: '#49B187',
        closed: '#223751',
        formLabel: '#292929',
        formError: '#DC2626',
        formInput: 'rgba(0, 0, 0, 0.1)',
        modalBackdrop: '#373737',
        lightShadow: 'rgba(0, 0, 0, 0.05)',
        mediumShadow: 'rgba(0, 0, 0, 0.1)',
        darkShadow: 'rgba(0, 0, 0, 0.15)',
        outline: '#95CCFF',

        // Colors for buttons
        buttonPrimaryBg: '#223751',
        buttonPrimaryBgHover: '#43556B',
        buttonPrimaryBgActive: '#59697D',
    },
    boxShadow: {
        primary: '0 0 9px 3px rgba(0, 0, 0, 0.0428125)',
        primaryHover: '0 0 9px 3px rgba(73, 177, 135, 0.4)',
    },
    transitions: {
        hover: '200ms ease-in-out',
    },
};

export type TTheme = typeof theme;

export interface IStyledComponentsTheme {
    theme: TTheme;
}
